import { useMemo } from 'react'

import { isNilOrEmptyString, useFormatDate } from '@/shared/lib'

type Props = {
  startDate?: string
  endDate?: string
}

export const useDateRange = ({ startDate, endDate }: Props) => {
  const { formatDate } = useFormatDate()

  const dateRange = useMemo(() => {
    if (isNilOrEmptyString(startDate) || isNilOrEmptyString(endDate)) return ''

    return `${formatDate({ date: startDate, format: 'MM.dd' })} - ${formatDate({ date: endDate, format: 'MM.dd' })}`
  }, [startDate, endDate])

  return { dateRange }
}
